export default {"src":"/_next/static/media/vaessen-bg-blobs.d0ecb12f.svg","height":8447,"width":1920,"blurWidth":0,"blurHeight":0};